import { SkeletonLoaderModule } from '../skeleton-loader/skeleton-loader.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DeleteEntityComponent } from './delete-entity.component';
import { FormsModule } from '@angular/forms';
import { AiAssistantModule } from '../ai-assistant/ai-assistant.module';

@NgModule({
  declarations: [DeleteEntityComponent],
  imports: [
    SkeletonLoaderModule,
    CommonModule,
    FormsModule,
    AiAssistantModule
  ],
  exports: [DeleteEntityComponent],
  entryComponents: [DeleteEntityComponent]
})
export class DeleteEntityModule { }
